/**
 * Bloqueos del Calendario de Nóminas.
 *
 * El backend (`nominas/calendarios-de-nominas/bloqueos/`) regresa las funcionalidades cerradas
 * hoy, cada una con sus `rutas` del frontend. Una ruta aplica a la página exacta y a sus
 * sub-rutas (p. ej. '/reclutamiento' cubre '/reclutamiento/vacantes').
 *
 * El bloqueo real lo hace el backend; aquí solo se usa para avisar y deshabilitar botones.
 */

const normalizar = (ruta) => (ruta || '').replace(/\/+$/, '');

export const rutaCoincide = (ruta, pathname) => {
  const base = normalizar(ruta);
  const actual = normalizar(pathname);
  return !!base && (actual === base || actual.startsWith(`${base}/`));
};

/**
 * @param {object[]} bloqueos
 * @param {string} pathname
 * @returns {object[]} bloqueos que aplican a la ruta actual
 */
export const bloqueosDeRuta = (bloqueos, pathname) => (bloqueos || [])
  .filter((bloqueo) => (bloqueo.rutas || []).some((ruta) => rutaCoincide(ruta, pathname)));

export default bloqueosDeRuta;
